import { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPortalHasSavedLayouts } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getSelectedAddPanelTab } from 'EmailEditorUI/redux/selectors/selected';
import DefaultSections from 'LayoutBuilderUI/components/panels/sidebar/DefaultSections';
import ModulesSections from 'LayoutBuilderUI/components/panels/sidebar/ModulesSections';
// @ts-expect-error Cannot find declaration for module
import SavedSectionsPanelSection from 'LayoutBuilderUI/components/panels/SavedSectionsPanelSection';
import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PanelNavigation = () => {
  const selectedTab = useSelector(getSelectedAddPanelTab);
  const hasSavedLayouts = useSelector(getPortalHasSavedLayouts);
  useEffect(() => {
    try {
      window.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].scrollTo(0, 0);
    } catch (error) {
      // dissolve
    }
  }, [selectedTab]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(selectedTab === 'modules' || !selectedTab) && /*#__PURE__*/_jsx(ModulesSections, {}), selectedTab === 'sections' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DefaultSections, {}), hasSavedLayouts && /*#__PURE__*/_jsx(SavedSectionsPanelSection, {})]
    })]
  });
};
export default /*#__PURE__*/memo(PanelNavigation);